import { gql } from '@apollo/client';

const HOLTER_EVENTS_DAILY_COUNT_QUERY = gql`
  query holterEventsDailyCount($filter: HolterEventsFilter!) {
    holterEventsDailyCount(filter: $filter) {
      isSuccess
      message
      eventCounts {
        date
        count
      }
    }
  }
`;

export default HOLTER_EVENTS_DAILY_COUNT_QUERY;
